import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UserCardService} from "../service/user-card.service";

@Component({
  selector: 'app-cards-by-qr-username-component',
  templateUrl: './cards-by-qr-username.component.html',
  styleUrl: './cards-by-qr-username.component.scss'
})
export class CardsByQrUsernameComponent implements OnInit {

  showError: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userCardService: UserCardService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      const qrCode = params['qrCode'];
      if (qrCode) {
        this.fetchUsername(qrCode);
      } else {
        this.handleError();
      }
    });
  }

  private fetchUsername(qrCode: string): void {
    this.userCardService.getUsernameByQrUsername(qrCode).subscribe({
      next: (username) => this.handleSuccess(username),
      error: () => this.handleError()
    });
  }

  private handleSuccess(username: string | null): void {
    if (username) {
      this.router.navigate(['/', username]);
    } else {
      this.handleError();
    }
  }

  private handleError(): void {
    this.showError = true;
  }
}
